import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
} from './supportModels.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement } from '../../../kotlin-kotlin-stdlib/kotlin/internal/progressionUtil.mjs';
import { digitToInt2vo19zbx7ksb1 as digitToInt } from '../../../kotlin-kotlin-stdlib/kotlin/text/Char.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var RequiredTransferMethod_ACH_instance;
var RequiredTransferMethod_CheckOrWire_instance;
var RequiredTransferMethod_entriesInitialized;
function RequiredTransferMethod_initEntries() {
  if (RequiredTransferMethod_entriesInitialized)
    return Unit_instance;
  RequiredTransferMethod_entriesInitialized = true;
  RequiredTransferMethod_ACH_instance = RequiredTransferMethod().c9s('ACH', 0);
  RequiredTransferMethod_CheckOrWire_instance = RequiredTransferMethod().c9s('CheckOrWire', 1);
}
var RequiredTransferMethodClass;
function RequiredTransferMethod() {
  if (RequiredTransferMethodClass === VOID) {
    class $ extends Enum() {
      static c9s(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'RequiredTransferMethod');
    RequiredTransferMethodClass = $;
  }
  return RequiredTransferMethodClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.d9s_1 = function_0;
      }
      wi(a, b) {
        return this.d9s_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.d9s_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function SharedUtils$assertOrdering$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.b6l_1;
  var tmp$ret$1 = b.b6l_1;
  return compareValues(tmp, tmp$ret$1);
}
function RequiredTransferMethod_ACH_getInstance() {
  RequiredTransferMethod_initEntries();
  return RequiredTransferMethod_ACH_instance;
}
function RequiredTransferMethod_CheckOrWire_getInstance() {
  RequiredTransferMethod_initEntries();
  return RequiredTransferMethod_CheckOrWire_instance;
}
var SharedUtilsClass;
function SharedUtils() {
  if (SharedUtilsClass === VOID) {
    class $ {
      constructor() {
        SharedUtils_instance = this;
        this.e9s_1 = Regex().qh('^[a-zA-Z0-9-+._]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+[a-zA-Z0-9-]$');
        this.f9s_1 = Regex().qh('(?:\\+\\d+ )?\\(\\d{3}\\) \\d{3}-\\d{4}|(?:\\+\\d+)?\\d{10}|(?:\\+\\d+-)?\\d{3}-\\d{3}-\\d{4}|(?:\\+\\d+ )?\\d{3} \\d{3} \\d{4}');
        this.g9s_1 = '\xAF\\_(\u30C4)_/\xAF';
        this.h9s_1 = 'https://1000logos.net/wp-content/uploads/2023/10/Shrug-Kaomoji.png';
        this.i9s_1 = 'Mock Payment';
        this.j9s_1 = 'mock';
        this.k9s_1 = Companion_getInstance().xw('00000000-0000-0000-0000-000000000000');
        this.l9s_1 = 'An unknown error occurred.';
        this.m9s_1 = Companion_instance.n9s(5000);
      }
      o9s(amount) {
        return MonetaryValue__compareTo_impl_w7ul1r(amount, this.m9s_1) > 0 ? RequiredTransferMethod_CheckOrWire_getInstance() : RequiredTransferMethod_ACH_getInstance();
      }
      p9s(value) {
        var tmp;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.text.any' call
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(value)) {
            var element = charSequenceGet(value, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            if (!isDigit(element)) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        if (tmp$ret$1) {
          tmp = true;
        } else {
          tmp = !(value.length === 9);
        }
        if (tmp)
          return false;
        var check = 0;
        var nestedLast = charSequenceLength(value) - 1 | 0;
        var inductionVariable_0 = 0;
        var last = getProgressionLastElement(0, nestedLast, 3);
        if (inductionVariable_0 <= last)
          do {
            var index = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 3 | 0;
            check = check + imul(digitToInt(charCodeAt(value, index)), 3) | 0;
            check = check + imul(digitToInt(charCodeAt(value, index + 1 | 0)), 7) | 0;
            check = check + digitToInt(charCodeAt(value, index + 2 | 0)) | 0;
          }
           while (!(index === last));
        return !(check === 0) && (check % 10 | 0) === 0;
      }
      q9s(items, minimum, maximum) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = SharedUtils$assertOrdering$lambda;
        // Inline function 'kotlin.comparisons.thenBy' call
        var this_0 = new (sam$kotlin_Comparator$0())(tmp);
        var tmp_0 = (a, b) => {
          var previousCompare = this_0.compare(a, b);
          var tmp;
          if (!(previousCompare === 0)) {
            tmp = previousCompare;
          } else {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp_0 = a.l6k_1;
            var tmp$ret$2 = b.l6k_1;
            tmp = compareValues(tmp_0, tmp$ret$2);
          }
          return tmp;
        };
        var tmp$ret$4 = new (sam$kotlin_Comparator$0())(tmp_0);
        // Inline function 'kotlin.collections.groupBy' call
        var tmp0 = sortedWith(items, tmp$ret$4);
        // Inline function 'kotlin.collections.groupByTo' call
        var destination = LinkedHashMap().f6();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var key = element.h6k_1;
          // Inline function 'kotlin.collections.getOrPut' call
          var value = destination.p3(key);
          var tmp_1;
          if (value == null) {
            var answer = ArrayList().w();
            destination.s3(key, answer);
            tmp_1 = answer;
          } else {
            tmp_1 = value;
          }
          var list = tmp_1;
          list.v(element);
        }
        // Inline function 'kotlin.collections.mapValues' call
        // Inline function 'kotlin.collections.mapValuesTo' call
        var destination_0 = LinkedHashMap().fc(mapCapacity(destination.p1()));
        // Inline function 'kotlin.collections.associateByTo' call
        var _iterator__ex2g4s_0 = destination.d2().m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          var tmp_2 = element_0.e2();
          // Inline function 'kotlin.collections.component2' call
          var projectGroup = element_0.f2();
          // Inline function 'kotlin.collections.groupBy' call
          // Inline function 'kotlin.collections.groupByTo' call
          var destination_1 = LinkedHashMap().f6();
          var _iterator__ex2g4s_1 = projectGroup.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            var key_0 = element_1.j6k_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value_0 = destination_1.p3(key_0);
            var tmp_3;
            if (value_0 == null) {
              var answer_0 = ArrayList().w();
              destination_1.s3(key_0, answer_0);
              tmp_3 = answer_0;
            } else {
              tmp_3 = value_0;
            }
            var list_0 = tmp_3;
            list_0.v(element_1);
          }
          destination_0.s3(tmp_2, destination_1);
        }
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_2 = ArrayList().w();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_2 = destination_0.d2().m1();
        while (_iterator__ex2g4s_2.n1()) {
          var element_2 = _iterator__ex2g4s_2.o1();
          // Inline function 'kotlin.collections.component2' call
          var projectGroup_0 = element_2.f2();
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination_3 = ArrayList().w();
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_3 = projectGroup_0.d2().m1();
          while (_iterator__ex2g4s_3.n1()) {
            var element_3 = _iterator__ex2g4s_3.o1();
            // Inline function 'kotlin.collections.component2' call
            var group = element_3.f2();
            var step = (maximum - minimum) / (group.p1() + 1 | 0);
            // Inline function 'kotlin.collections.mapIndexed' call
            // Inline function 'kotlin.collections.mapIndexedTo' call
            var destination_4 = ArrayList().u(collectionSizeOrDefault(group, 10));
            var index = 0;
            var _iterator__ex2g4s_4 = group.m1();
            while (_iterator__ex2g4s_4.n1()) {
              var item = _iterator__ex2g4s_4.o1();
              var _unary__edvuaz = index;
              index = _unary__edvuaz + 1 | 0;
              var idx = checkIndexOverflow(_unary__edvuaz);
              var tmp$ret$25 = item.i6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, minimum + step * (idx + 1 | 0));
              destination_4.v(tmp$ret$25);
            }
            var list_1 = destination_4;
            addAll(destination_3, list_1);
          }
          var list_2 = destination_3;
          addAll(destination_2, list_2);
        }
        return destination_2;
      }
      r9s(items, minimum, maximum, $super) {
        minimum = minimum === VOID ? 0.0 : minimum;
        maximum = maximum === VOID ? 1.0 : maximum;
        return $super === VOID ? this.q9s(items, minimum, maximum) : $super.q9s.call(this, items, minimum, maximum);
      }
    }
    initMetadataForObject($, 'SharedUtils');
    SharedUtilsClass = $;
  }
  return SharedUtilsClass;
}
var SharedUtils_instance;
function SharedUtils_getInstance() {
  if (SharedUtils_instance === VOID)
    new (SharedUtils())();
  return SharedUtils_instance;
}
//region block: exports
export {
  RequiredTransferMethod_ACH_getInstance as RequiredTransferMethod_ACH_getInstance3m8mkmk5y1ml8,
  RequiredTransferMethod_CheckOrWire_getInstance as RequiredTransferMethod_CheckOrWire_getInstance2c8njn9raqmay,
  SharedUtils_getInstance as SharedUtils_getInstanceggolgle4lzs6,
};
//endregion

//# sourceMappingURL=sharedUtils.mjs.map
